import { render, staticRenderFns } from "./CRYPTO_TermsAndConditions.vue?vue&type=template&id=540e5cce&"
import script from "./CRYPTO_TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./CRYPTO_TermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CRYPTO_TermsAndConditions.vue"
export default component.exports